// npm
import styled from 'styled-components'
import { useEffect, useState } from 'react'
// components
import { Layout, MagazineCard } from '../components'
// firebase
import { db } from '../firebase'

const MagazineList = () => {

    const [magazineList, setMagazineList] = useState([])
    const [tempList] = useState([])

    useEffect( () => {
        db.collection('magazines')
            .orderBy("created_at", "desc")
            .get()
            .then(snapshots => {
                snapshots.forEach(snapshot => {
                    const data = snapshot.data()
                    tempList.push({
                        id: data.id,
                        external: data.external,
                        externalLink: data.externalLink,
                        title: data.title,
                        image: data.image,
                        date: data.created_at,
                        isDraft: data.isDraft,
                        isTrash: data.isTrash,
                        category: data.category
                    })
                })
                setMagazineList(tempList)
            })
        return null
    }, [tempList])

    return (
        <Layout>
            <div className='spacer-100' />
            <h1>Magazine List</h1>
            <div className='spacer-50' />
            <MagazineListWrapper>
                { magazineList.length > 0 && (
                    magazineList.map(magazine => (
                        <MagazineCard 
                            key={magazine.id} id={magazine.id} 
                            external={magazine.external}
                            externalLink={magazine.externalLink}
                            title={magazine.title}
                            image={magazine.image}
                            date={magazine.date}
                            category={magazine.category}
                            isDraft={magazine.isDraft}
                            isTrash={magazine.isTrash}
                        />
                    )) 
                )}
            </MagazineListWrapper>
            <div className='spacer-100' />
        </Layout>
    )
}

export default MagazineList

const MagazineListWrapper = styled.div`
    width: 640px;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100%;
    }
`